import script from "./ManageSubOrg.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSubOrg.vue?vue&type=script&setup=true&lang=js"

import "./ManageSubOrg.vue?vue&type=style&index=0&id=e544f262&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e544f262"]])

export default __exports__